<template>
  <div>
    <p>{{ label }}</p>
    <input
      v-if="type != 'singleMonth'"
      class=""
      type="month"
      v-model="startTime"
      name="commonMonthInput"
    />
    <template v-else>
      <select
        class="custom-select"
        style="
          max-width: 9rem;
          width: 110px;
          height: 2.375rem;
          font-size: 0.875rem;
          border: 2px solid rgb(255, 255, 255);
          box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px;
          color: rgb(95, 95, 95);
        "
        v-model="selected"
        name="commonSelectInput"
      >
        <option value="">不限月份</option>
        <option v-for="option in 12" :value="option" :disabled="option == ''">
          {{ option }}
        </option>
      </select>
    </template>
    <template v-if="type == 'monthBetween'">
      ~
      <input class="" type="month" v-model="endTime" />
    </template>
  </div>
</template>

<script>
import { ref, watch } from "@vue/runtime-core";
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "month", // month/monthBetween/singleMonth
    },
  },
  emits: ["update:getValue"],
  setup(props, { emit }) {
    const startTime = ref();
    const endTime = ref();

    watch(
      startTime,
      (newValue) => {
        if (props.type == "monthBetween") {
          emit("update:getValue", {
            startTime: newValue,
            endTime: endTime.value,
          });
        } else {
          emit("update:getValue", newValue);
        }
      },
      { deep: true }
    );

    if (props.type == "monthBetween") {
      watch(
        endTime,
        (newValue) => {
          emit("update:getValue", {
            startTime: startTime.value,
            endTime: newValue,
          });
        },
        { deep: true }
      );
    }

    const selected = ref("");
    if (props.type == "singleMonth") {
      if (props.disableValue !== null) {
        selected.value = props.disableValue;
        emit("update:getValue", selected.value);
      } else {
        selected.value = "";
        emit("update:getValue", selected.value);
      }

      watch(
        selected,
        (newValue) => {
          emit("update:getValue", newValue);
        },
        { deep: true }
      );

      selected.value = "";
    }

    return {
      startTime,
      endTime,
      selected,
    };
  },
};
</script>

<style scoped>
p {
  margin-bottom: 10px;
}
input[type="month"] {
  max-width: 9rem;
  height: 2.375rem;
  font-size: 0.875rem;
  border: 2px solid rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
  color: rgb(95, 95, 95);
}
.custom-select {
  display: inline-block;
  width: 100%;
  height: 2.375rem;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  color: #495057;
  vertical-align: middle;
  background: #fff
    url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5'%3E%3Cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3E%3C/svg%3E")
    no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
}
</style>
